import { queryOptions } from "@tanstack/react-query";
import { docsApi } from "./docs-api";

export const docsQueries = {
  byDocumentId: (documentId: string) =>
    queryOptions({
      queryKey: ["documents", documentId],
      queryFn: () => docsApi.getDocument(documentId),
    }),
  /** Prefix of every byContainer list (CR-263 invalidates it on a share). */
  lists: () => ["documents", "containers"] as const,
  byContainer: (containerId: string) =>
    queryOptions({
      queryKey: [...docsQueries.lists(), containerId],
      queryFn: () => docsApi.listDocuments(containerId),
    }),
};
